<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 6H20C21.1046 6 22 6.89543 22 8V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6C2 4.89543 2.89543 4 4 4H10L12 6ZM4 5C3.72609 4.96742 3.45189 5.06178 3.25684 5.25684C3.06178 5.45189 2.96742 5.72609 3 6V18C2.96742 18.2739 3.06178 18.5481 3.25684 18.7432C3.45189 18.9382 3.72609 19.0326 4 19H20C20.2739 19.0326 20.5481 18.9382 20.7432 18.7432C20.9382 18.5481 21.0326 18.2739 21 18V8C21.0326 7.72609 20.9382 7.45189 20.7432 7.25684C20.5481 7.06178 20.2739 6.96742 20 7H11.5996L9.59961 5H4ZM20 9H4V8H20V9Z"
      fill="currentColor"
    />
  </svg>
</template>
